/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/aria-role */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable i18next/no-literal-string */
import { GridCellParams } from '@mui/x-data-grid-pro';
import { useGridApiContext } from '@mui/x-data-grid-pro';
import { Box, ClickAwayListener, TextField, Autocomplete } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { useEffect } from 'react';
import WarningIcon from '@mui/icons-material/Warning';
import { CustomTooltip } from 'app/components/Common/Tooltips';
import statesData from 'app/assets/jsons/State.json';

const useStyles: any = makeStyles()({
  hidden: {
    display: 'none',
  },
  input: {
    width: '100%',
    height: '30px',
    border: 'none',
    '&:focus': {
      border: '1px dotted gray',
      outline: 'none',
    },
  },
  inputInvalid: {
    color: 'red',
  },
  inputValid: {
    color: '#a3a2a2',
  },
  autoComplete: {
    '& .MuiAutocomplete-inputRoot .MuiAutocomplete-input ': {
      height: '35px',
    },
  },
});

interface CityState {
  label: string;
  id: string;
}

interface GridAutoCompleteCellProps {
  onEndEdit: ({ value, params }: { value: string; params: GridCellParams }) => void;
  validator?: ({ value, params }: { value: string; params: GridCellParams }) => boolean;
  placeholder?: string;
  mandatory?: boolean;
  editOnSingleClick?: boolean;
  Input?: any;
  autoCompleteOptions?: any[];
  fetchData?: (value: string, callback: (res) => void) => void;
  externalValidator?: ({ value, params }: { value: string; params: GridCellParams }) => any;
  disabled?: boolean;
}

export const GridAutoCompleteCell =
  ({ ...props }: GridAutoCompleteCellProps) =>
  (params: GridCellParams) => {
    return <XGridEditableCellContent params={params} props={props} />;
  };

const XGridEditableCellContent = ({ props, params }: { props: GridAutoCompleteCellProps; params: GridCellParams }) => {
  const { classes, cx } = useStyles();
  const api = useGridApiContext();
  const {
    onEndEdit,
    validator,
    placeholder,
    mandatory,
    editOnSingleClick = false,
    Input,
    fetchData,
    externalValidator,
    disabled = false,
  } = props;

  const [editing, setEditing] = React.useState<boolean>(false);
  const [editValue, setEditValue] = React.useState<any>(params.value);
  const [valid, setValid] = React.useState<boolean>(true);
  const [firstInteraction, setFirstInteraction] = React.useState<boolean>(true);
  const [cities, setCities] = React.useState<any>();

  React.useEffect(() => {
    setEditValue(params.value);
    if (validator && !firstInteraction) {
      setValid(validator({ value: editValue, params: params }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.value, validator]);

  React.useEffect(() => {
    if (validator && !firstInteraction) {
      setValid(validator({ value: editValue, params: params }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, params.value, validator]);

  React.useEffect(() => {
    setEditValue(params.value);
    if (externalValidator && !firstInteraction) {
      setValid(externalValidator({ value: editValue, params: params }) ? false : true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.value, externalValidator]);

  const startEditing = React.useCallback(() => {
    setFirstInteraction(false);
    if (!editOnSingleClick) setEditing(true);
    setTimeout(() => {
      if (editOnSingleClick) setEditing(true);
      document.getElementById(`grid-cell-input-${params.row.id}-${params.colDef.field}`)?.focus();
    }, 100);
  }, [editOnSingleClick, params.colDef.field, params.row.id]);

  const _onEndEditing = () => {
    if (editing) {
      setEditing(false);
      api?.current?.updateRows([{ ...params.row, [params.colDef.field]: editValue }]);
      onEndEdit({ value: editValue, params: params });
      if (validator) {
        setValid(validator({ value: editValue, params: params }));
      }
    }
  };

  useEffect(() => {
    setEditValue(params.row.city);
  }, [params.row.city]);

  const onKeyUp = React.useCallback(
    event => {
      if (
        event.keyCode === 13 &&
        document.activeElement?.getAttribute('data-field') === params.field &&
        document.activeElement?.getAttribute('data-rowindex') ===
          `${api?.current?.getRowIndexRelativeToVisibleRows(params.id)}`
      ) {
        startEditing();
      }
    },
    [api, params.field, params.id, startEditing],
  );

  React.useEffect(() => {
    document.addEventListener('keyup', onKeyUp);
    return () => {
      document.removeEventListener('keyup', onKeyUp);
    };
  }, [onKeyUp, params]);

  const onInputChanged = value => {
    setEditValue(value);
  };

  const onChange = (event, newInputValue) => {
    if (newInputValue?.label !== '') {
      const city = newInputValue?.label.substring(0, newInputValue?.label.indexOf(','));
      const state = newInputValue?.label.substring(newInputValue?.label?.indexOf(',') + 2, newInputValue?.label.length);
      const { tagName } = event.currentTarget;
      setEditValue(prevValue => (tagName === 'LI' ? prevValue : city));
      api?.current.updateRows([
        {
          ...params.row,
          [params.colDef.field]: city,
          state: newInputValue?.label
            ? statesData.states.find(x => x.Description === state)?.StateNumber
            : params.row.state,
          stateProvinceID: newInputValue?.label
            ? statesData.states.find(x => x.Description === state)?.ID
            : params.row.stateProvinceID,
        },
      ]);
    }
  };
  const onInputChange = (event, newInputValue: string) => {
    if (event) {
      const { tagName } = event.currentTarget;
      setEditValue(prevValue => (tagName === 'LI' ? prevValue : newInputValue));
    }
  };

  useEffect(() => {
    if (editing && editValue && params.row.country === 'USA' && editValue.length > 1) {
      fetchData?.(editValue, data => {
        if (data) {
          const temp: any[] = [];
          data.forEach((x, idx) => {
            if (x.city) {
              temp.push({ label: `${x.city}, ${x.stateDescription}`, id: idx });
            }
          });
          setCities(temp);
        } else setCities([]);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editValue]);

  return (
    <React.Fragment>
      <ClickAwayListener mouseEvent="onMouseDown" onClickAway={_onEndEditing}>
        <div style={{ width: '100%' }} className={cx({ [classes.hidden]: !editing })}>
          {Input ? (
            <Input params={params} onChange={onInputChanged} onEndEdit={_onEndEditing} />
          ) : params.row.country !== 'USA' ? (
            <input
              autoComplete="off"
              id={`grid-cell-input-${params.row.id}-${params.colDef.field}`}
              onChange={event => onInputChanged(event.target.value)}
              value={editValue}
              className={cx(classes.input)}
              onSubmit={_onEndEditing}
              onKeyDown={event => event.stopPropagation()}
              onKeyUp={event => {
                if (event.keyCode === 13) _onEndEditing();
                else if (event.keyCode === 27) {
                  setEditValue(params.value);
                  setEditing(false);
                }
              }}
            />
          ) : (
            <Autocomplete
              className={classes.autoComplete}
              renderInput={p => <TextField {...p} />}
              onInputChange={onInputChange}
              onChange={onChange}
              isOptionEqualToValue={(option, value) => option.label === value.label}
              getOptionLabel={(option: CityState) => option.label || ''}
              options={cities || []}
              value={params.row.city || ''}
              inputValue={editValue ? editValue : params.row.city || ''}
            ></Autocomplete>
          )}
        </div>
      </ClickAwayListener>
      <Box
        onClick={editOnSingleClick ? startEditing : undefined}
        onDoubleClick={!editOnSingleClick ? startEditing : undefined}
        className={cx({
          [classes.hidden]: editing,
          [classes.inputInvalid]:
            (!valid || params.row[`${params.field}_error`] === true) &&
            params.row.city === null &&
            params.row.country !== 'USA',
        })}
        style={{ width: '100%', minHeight: '20px' , pointerEvents: disabled ? 'none' : 'auto'}}
      >
        {params.row.city ? (
          externalValidator?.({ value: editValue, params: params }) ? (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ padding: '0px 5px 2px 0px' }}>
                <CustomTooltip tooltipContent={externalValidator?.({ value: editValue, params: params })}>
                  <WarningIcon style={{ color: 'red', height: '14px', width: '14px' }} />
                </CustomTooltip>
              </span>
              <span
                className={cx({
                  [classes.inputInvalid]: !valid || params.row[`${params.field}_error`] === true,
                  [classes.inputValid]: valid && !params.row[`${params.field}_error`],
                })}
              >
                {params.colDef.field === 'state' && (params.row.country === 'USA' || params.row.country === 'Canada')
                  ? statesData.states.find(x => x.StateNumber === editValue || x.ID === editValue)?.Description
                  : editValue}
              </span>
            </div>
          ) : params.colDef.field === 'state' ? (
            statesData.states.find(x => x.StateNumber === editValue || x.ID === editValue)?.Description
          ) : (
            params.row.city
          )
        ) : (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {mandatory && (!validator?.({ value: params.value?.toString(), params }) || false) && (
              <span style={{ padding: '0px 5px 2px 0px' }}>
                <CustomTooltip tooltipContent={'This field is required'}>
                  <WarningIcon style={{ color: 'red', height: '14px', width: '14px' }} />
                </CustomTooltip>
              </span>
            )}
            <span
              className={cx({
                [classes.inputInvalid]: !valid || params.row[`${params.field}_error`] === true,
                [classes.inputValid]: valid && !params.row[`${params.field}_error`],
              })}
            >{`${placeholder || params.colDef.headerName}`}</span>
          </div>
        )}
      </Box>
    </React.Fragment>
  );
};
